import { makeAutoObservable } from 'mobx'

export class ListLayoutStore {
  constructor() {
    makeAutoObservable(this)
  }

  private _loading = true
  get loading() {
    return this._loading
  }
  setLoading = (value: boolean) => {
    this._loading = value
  }

  private _isEmpty = false
  get isEmpty() {
    return this._isEmpty
  }
  setIsEmpty = (value: boolean) => {
    this._isEmpty = value
  }

  get isHideChildContent() {
    return this.loading || this._isEmpty
  }
}
